export default __webpack_public_path__ + "static/media/Aura-Egg__53.9e9c7a1a.png";